var map = {
	"./Analytical.png": 72,
	"./Discount.png": 73,
	"./Group.png": 74,
	"./Located.png": 75,
	"./Transaction.png": 76,
	"./TransactionOG.png": 77,
	"./Transcation origination.png": 78,
	"./Value.png": 79,
	"./logo.png": 21,
	"./market-info-graph-mobile.png": 80,
	"./market-info-graph.png": 81,
	"./marketinfographfinal.png": 29,
	"./nycref-logo.png": 82,
	"./protection.png": 83,
	"./structures.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;